import { render, staticRenderFns } from "./ParticipantMerge.vue?vue&type=template&id=0ebe099c"
import script from "./ParticipantMerge.vue?vue&type=script&lang=js"
export * from "./ParticipantMerge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports